const googleConfig = {
  analyticsID: 'G-V7Y21F56E7'
};

export default googleConfig;